import { Building2, Handshake, Users, Briefcase, ArrowRight } from "lucide-react";

const WHO_WE_HELP = [
    { icon: Building2, title: "Builders & Developers", body: "Generate demand for projects and available inventory." },
    { icon: Handshake, title: "Real Estate Brokers", body: "Build a consistent flow of buyer enquiries." },
    { icon: Users, title: "Channel Partners", body: "Generate enquiries for specific projects and micro-markets." },
    { icon: Briefcase, title: "Real Estate Consultants", body: "Scale lead generation without building a large in-house marketing team." },
];

const WHY_LEADKRAFTS = [
    { title: "Precision Targeting", body: "Reach buyers based on location, property type, budget and intent." },
    { title: "AI Qualification", body: "Help sales teams prioritize higher-intent enquiries." },
    { title: "Fast Lead Delivery", body: "Get new enquiries into your sales workflow quickly." },
    { title: "Transparent Reporting", body: "Track campaign and lead performance." },
    { title: "Continuous Optimization", body: "Improve campaigns based on actual performance data." },
];

export default function BrandLogos() {
    return (
        <section id="brands" data-testid="brands-section" className="py-24 sm:py-32 px-6 sm:px-10 lg:px-16 border-t border-white/5">
            <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-12 lg:gap-16">
                <div className="lg:col-span-7">
                    <div className="flex items-center gap-3 mb-6">
                        <div className="h-px w-10 bg-[#D4AF37]" />
                        <span className="overline">Who We Help</span>
                    </div>
                    <h2 className="font-serif-display text-4xl sm:text-5xl tracking-tight leading-[1.05]">
                        Built for India's <br />
                        <span className="italic text-[#D4AF37]">real estate growth teams</span>.
                    </h2>
                    <p className="mt-6 text-white/60 max-w-lg">
                        Lead Krafts helps real-estate businesses generate qualified buyer enquiries using
                        AI-powered digital marketing — whichever side of the business you're on.
                    </p>
                    <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-4" data-testid="categories-served-grid">
                        {WHO_WE_HELP.map((c) => (
                            <div key={c.title} className="hol-card p-6 flex flex-col items-start gap-3">
                                <c.icon size={18} className="text-[#D4AF37]" strokeWidth={1.5} />
                                <div className="font-serif-display text-lg text-white leading-tight">{c.title}</div>
                                <div className="text-sm text-white/60 leading-relaxed">{c.body}</div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="lg:col-span-5">
                    <div data-testid="commitment-panel" className="sticky top-32 border border-[#D4AF37]/30 bg-[#0A0B10] p-8">
                        <div className="flex items-center gap-3 mb-6">
                            <span className="overline">Why Lead Krafts</span>
                        </div>
                        <h3 className="font-serif-display text-2xl leading-tight">
                            Built on <span className="italic text-[#D4AF37]">precision</span>, not guesswork.
                        </h3>
                        <ul className="mt-8 space-y-5">
                            {WHY_LEADKRAFTS.map((c) => (
                                <li key={c.title} className="flex items-start gap-3">
                                    <span className="mt-1.5 h-1.5 w-1.5 bg-[#D4AF37] shrink-0" />
                                    <div>
                                        <div className="text-sm text-white font-medium">{c.title}</div>
                                        <div className="text-sm text-white/60 leading-relaxed">{c.body}</div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                        <a href="#lead" data-testid="brands-cta" className="btn-gold mt-8 w-full justify-center">
                            Get More Qualified Leads <ArrowRight size={14} />
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}
